import { ActionType } from "./actions";
import { IFilter } from "../../../classes/filter";
import { MediaGalleryAppState } from "../../../classes/index";
import { Dispatch } from "react-redux";
import { storeFilteredMedia } from "./media-api";

function upsertFilter(filter: IFilter) {
    return {
        type: ActionType.UPSERT_FILTER,
        value: filter
    }
}

export function applyFilter(filter: IFilter) {
    return (dispatch: Dispatch<MediaGalleryAppState>, getState: () => MediaGalleryAppState) => {
        dispatch(upsertFilter(filter));

        const state = getState();
        const filteredMedia = state.mediaApiModel.mediaList.filter(state.filterModel.combinedFilter)

        dispatch(storeFilteredMedia(filteredMedia));
    }
}

export function removeFilter(key: string) {

    return (dispatch: Dispatch<MediaGalleryAppState>, getState: () => MediaGalleryAppState) => {
        dispatch({ type: ActionType.REMOVE_FILTER, value: key });

        const state = getState();
        const filteredMedia = state.mediaApiModel.mediaList.filter(state.filterModel.combinedFilter)

        dispatch(storeFilteredMedia(filteredMedia));
    }
}

export function removeAllFilters() {
    return (dispatch: Dispatch<MediaGalleryAppState>, getState: () => MediaGalleryAppState) => {
        dispatch({ type: ActionType.REMOVE_ALL_FILTERS });

        const state = getState();
        const filteredMedia = state.mediaApiModel.mediaList.filter(state.filterModel.combinedFilter)

        dispatch(storeFilteredMedia(filteredMedia));
    }
}


// WEBPACK FOOTER //
// ./app/media-gallery/redux/actions/filters.ts